import { apiFetch } from '@/lib/api'

export function getDealEvidence(dealId, options = {}) {
  return apiFetch(`/api/v1/deals/${dealId}/evidence`, options)
}

export function collectDealEvidence(dealId, request, options = {}) {
  return apiFetch(`/api/v1/deals/${dealId}/evidence/collections`, {
    ...options,
    method: 'POST',
    body: { deal_evidence_collection: request },
  })
}

export function getDealEvidenceCollection(dealId, runId, options = {}) {
  return apiFetch(`/api/v1/deals/${dealId}/evidence/collections/${runId}`, options)
}

export function reviewDealEvidence(dealId, request, options = {}) {
  return apiFetch(`/api/v1/deals/${dealId}/evidence/reviews`, {
    ...options,
    method: 'POST',
    body: { deal_evidence_review: request },
  })
}
